import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { useThemeMode } from '../../../../context/ThemeContext';

const ThemeToggle = () => {
  const { themeMode, toggleTheme } = useThemeMode();

  const getIcon = () => {
    switch (themeMode) {
      case 'light':
        return <LightModeIcon sx={{ fontSize: '1.3rem' }} />;
      case 'dark':
        return <DarkModeIcon sx={{ fontSize: '1.3rem' }} />;
      case 'system':
        return <SettingsBrightnessIcon sx={{ fontSize: '1.3rem' }} />;
      default:
        return <LightModeIcon sx={{ fontSize: '1.3rem' }} />;
    }
  };

  const getTooltipTitle = () => {
    switch (themeMode) {
      case 'light':
        return 'Light Mode';
      case 'dark':
        return 'Dark Mode';
      case 'system':
        return 'System Theme';
      default:
        return 'Light Mode';
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={getTooltipTitle()} arrow>
        <IconButton
          onClick={toggleTheme}
          color="inherit"
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)'
            }
          }}
        >
          {getIcon()}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ThemeToggle;

